// This is the complete transport boundary; the iframe cannot choose hosts or arbitrary APIs.
export const builderFeatures = {
  automations: { title: 'Groove Automations', legacyTitle: 'Groove Automations Legacy', path: '/automations/new', legacy: '/automations/legacy', source: '/automations' },
  sequences: { title: 'Groove Sequence Builder', legacyTitle: 'Sequence Builder Legacy', path: '/sequences/new', legacy: '/sequences/legacy', source: '/campaigns/sequences' },
  segments: { title: 'Segment Builder', legacyTitle: 'Segment Builder Legacy', path: '/segments/new', legacy: '/segments/legacy', source: '/lists/segments' }
};
const endpointRules = [
  [/^\/api\/storage\/upload$/, ['POST']],
  [/^\/api\/integrations\/composio(?:\/tools)?$/, ['GET']],
  [/^\/api\/bootstrap$/, ['GET']],
  [/^\/api\/(automations|sequences|segments)$/, ['GET', 'POST']],
  [/^\/api\/(automations|sequences|segments)\/[a-zA-Z0-9_-]+$/, ['GET', 'POST', 'PATCH', 'PUT', 'DELETE']],
  [/^\/api\/(automations|sequences|segments)\/[a-zA-Z0-9_-]+\/(activate|pause|clone|restore)$/, ['POST']],
  [/^\/api\/automations\/catalog\/[a-zA-Z0-9_-]+$/, ['GET']],
  [/^\/api\/sequences\/(nodes|edges)\/[a-zA-Z0-9_-]+$/, ['GET', 'PATCH', 'PUT', 'DELETE']],
  [/^\/api\/segments\/[a-zA-Z0-9_-]+\/contacts$/, ['GET']],
  [/^\/api\/contacts\/audience-actions$/, ['POST']],
  [/^\/api\/contacts\/audience-actions\/status$/, ['GET']]
];
export function allowedRequest(path, method) {
  if (typeof path !== 'string' || path.length > 4096 || /[\\\u0000-\u0020#]/.test(path)) return false;
  const parts = path.split('?');
  return parts.length <= 2 && endpointRules.some(([pattern, methods]) => pattern.test(parts[0]) && methods.includes(method));
}
export function sourceRoute(feature, route) {
  const config = builderFeatures[feature];
  if (!config) return null;
  const id = route.params && route.params.id;
  const query = new URLSearchParams(route.query || {}).toString();
  return config.source + (id ? '/' + (feature === 'segments' && id === 'new' ? 'builder' : encodeURIComponent(id)) : '') + (query ? '?' + query : '');
}
export function grooveRoute(sourcePath) {
  if (typeof sourcePath !== 'string' || /[\\\u0000-\u0020]/.test(sourcePath) || !sourcePath.startsWith('/') || sourcePath.startsWith('//')) return null;
  if (sourcePath === '/settings/brand-footers') return '/settings?type=sender';
  if (sourcePath === '/templates' || sourcePath === '/templates/new') return '/templates/new';
  for (const feature of Object.keys(builderFeatures)) {
    const config = builderFeatures[feature];
    const path = sourcePath.split('?')[0];
    if (path !== config.source && !path.startsWith(config.source + '/')) continue;
    const suffix = path.slice(config.source.length).replace(/^\//, '');
    if (suffix && !/^[a-zA-Z0-9_-]+$/.test(suffix)) return null;
    const id = suffix === 'builder' ? 'new' : suffix;
    return config.path + (id ? '/' + id : '') + (sourcePath.includes('?') ? '?' + sourcePath.split('?')[1] : '');
  }
  return null;
}
export function isFrameMessage(event, frame, channel, origin) {
  return Boolean(frame && event.source === frame.contentWindow && event.origin === origin && event.data && event.data.channel === channel);
}
export function responseBody(error) {
  const body = error && error.response && error.response.data;
  if (body && body.error && typeof body.error.message === 'string') return body;
  const errors = body && body.errors;
  const detail = errors && Object.keys(errors).map(key => [].concat(errors[key]).join(' ')).join(' ');
  return { error: { message: detail || (body && body.message) || (error && error.message) || 'Unable to complete this request.' } };
}

export function uploadFormData(message) {
  const upload = message.upload;
  if (message.path !== '/api/storage/upload' || message.method !== 'POST' || message.body || !upload || upload.purpose !== 'template-images' || !(upload.file instanceof Blob) || upload.file.size < 1 || upload.file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(upload.file.type)) return null;
  const data = new FormData();
  data.append('file', upload.file, 'image.' + ({ 'image/jpeg': 'jpg', 'image/png': 'png', 'image/gif': 'gif', 'image/webp': 'webp' })[upload.file.type]);
  data.append('purpose', 'template-images');
  return data;
}
